<template>
  <v-layout style="height: 6%" align-center>
    <user-avatar height="45px" width="45px" class="ml-1 mr-1" />
    <span class="user-name"> {{ userName }}</span>

    <activate-two-authentication-dialog
      :open="opened2FArequired"
      @close="opened2FArequired = false "
      @activateAuthenticate="twoFactorAuthentication = true"
    />
  </v-layout>
</template>

<script>
import UserAvatar from "@/components/Home/NavBar/UserAvatar";
import ActivateTwoAuthenticationDialog from "@/components/User/Navbar/UserWindow/ActivateTwoAuthenticationDialog";
import { twoFactorAuthenticationMixin } from "@/mixins/twoFactorAuthenticationMixin";

export default {
  name: "UserInfo",

  components: { UserAvatar,
    ActivateTwoAuthenticationDialog },

    mixins: [twoFactorAuthenticationMixin],

    data() {
    return {
      userWindowOpen: false,
    };
  },

  mounted() {
    setTimeout(() => {
      this.companie2FArequired();
    }, 500)
  },

  computed: {
    /**
     * Get the name of the user who is logged in
     * @returns {any}
     */
    userName() {
      return this.$store.getters.currentUserName;
    }
  }
};
</script>

<style scoped>
.user-name {
  text-align: left;
  font: normal normal 600 15px Segoe UI;
  color: #32383d;
}
</style>



// WEBPACK FOOTER //
// src/components/Network/LeftSidebar/UserInfo.vue